import { ReportResource } from './report.resource';
import { report as reportStore } from '../../store';
import '../../config';
import { iframeStatus } from './report.store';
class ReportService {
    constructor() {
        this.reportResource = new ReportResource();
    }
    get(project, date) {
        return this.reportResource.getReport(project, date);
    }
    create(project, date) {
        return this.reportResource.create(project, date);
    }
    publish(project, date) {
        return this.reportResource.publish(project, date);
    }
    schedule(project, date) {
        return this.reportResource.schedule(project, date);
    }
    unschedule(project, date) {
        return this.reportResource.unschedule(project, date);
    }
    getList(project, pagination) {
        return this.reportResource.getList(project, pagination);
    }
    async getItemCounts(project, date) {
        const itemCounts = await this.reportResource.getItemCounts(project, date);
        reportStore.setItemCounts(itemCounts);
        return itemCounts;
    }
    previewReport(_, date) {
        // We will use _ as project later
        iframeStatus.set(true);
    }
}
export default new ReportService();
